import classNames from 'classnames'
import EmptyBlock from '../../components/common/EmptyBlock'

type NewSimpleContainerPropsType = {
  children?: React.ReactNode
  emptyFooter?: boolean
  noTopMargin?: boolean
}

const NewSimpleContainer = ({ emptyFooter, noTopMargin, children }: NewSimpleContainerPropsType) => {
  return (
    <div className={classNames(noTopMargin ? '' : 'mt-40', 'max-w-1040 mx-auto')}>
      {children}
      {emptyFooter && <EmptyBlock h={250} />}
    </div>
  )
}

export default NewSimpleContainer
